(function () {
  function initAcc(root) {
    if (root.dataset.accInit) return;
    root.dataset.accInit = 'true';

    var allowMultiple = root.dataset.allowMultiple === 'true';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-acc-item]'));

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-acc-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (!allowMultiple) {
          items.forEach(function (other) {
            if (other === item) return;
            other.classList.remove('is-open');
            var otherTrigger = other.querySelector('[data-acc-trigger]');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          });
        }

        item.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.acc').forEach(initAcc);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.acc') : null;
    if (root) initAcc(root);
  });
})();
